import { Button, TooltipTrigger } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import { config } from '~/config';

interface ShareTaskBtnProps {
  conversationId: string;
  taskId: string;
}

export const ShareTaskBtn = ({ conversationId, taskId }: ShareTaskBtnProps) => {
  const { t } = useTranslation('chat');

  return (
    <TooltipContainer
      label={t('chat:shareTask')}
      inPortal
      trigger={[TooltipTrigger.Hover]}
    >
      <Button
        data-testid="button-share-task"
        variant="empty"
        size="xsmall"
        iconName="Share"
        onClick={() => {
          const targetOrigin = config.ms.teamsParentUrl || '*';

          window.parent.postMessage(
            {
              type: 'adaptive-card',
              body: { conversationId, taskId },
            },
            targetOrigin
          );

          console.log('[ShareTaskBtn] postMessage sent', {
            conversationId,
            taskId,
            targetOrigin,
          });
        }}
      />
    </TooltipContainer>
  );
};
